module.exports = __webpack_public_path__ + "img/advil_dual_action_with_acetaminophen.13f6ae24.jpeg";